'use strict';

const $ = jQuery.noConflict();
import 'slick-carousel';

$(function() {
	const brandSlider = {
		sliderConfig: {
			centerMode: true,
			centerPadding: '15%',
			slidesToShow: 2,
			slidesToScroll: 1,
			autoplay: true,
			cssEase: 'ease-in-out',
			waitForAnimate: true,
			autoplaySpeed: 2300,
			pauseOnHover: true,
			speed: 700,
			arrows: true,
			infinite: true,
			swipe: true,
			rows: 0,
			responsive: [
				{
					breakpoint: 2000,
					settings: {
						centerPadding: '100px',
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 1199,
					settings: {
						centerPadding: '70px',
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 991,
					settings: {
						centerPadding: '30px',
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 767,
					settings: {
						centerPadding: '30px',
						slidesToShow: 1,
					}
				},
			],
		},

		init: function() {
			this.$sections = $('.brand-slider');

			if (!this.$sections.length) {
				return;
			}

			this.$sections.each((_, section) => {
				this.initSection($(section));
			});

			$(window).on('load.brandSlider', this.refreshAll.bind(this));
			$(window).on('resize.brandSlider', this.debounceRefresh.bind(this));
		},

		initSection: function($section) {
			const $slider = $section.find('.js-brand-slider-slider');
			const $wrap = $section.find('.brand-slider__slider-wrap');
			const slideCount = $slider.children('.brand-slider__item').length;

			if (!$slider.length || slideCount < 1 || $slider.hasClass('slick-initialized')) {
				return;
			}

			$slider.slick({
				...this.sliderConfig,
				prevArrow: $wrap.find('.js-brand-slider-prev'),
				nextArrow: $wrap.find('.js-brand-slider-next'),
			});
		},

		refreshAll: function() {
			$('.js-brand-slider-slider.slick-initialized').each((_, slider) => {
				$(slider).slick('setPosition');
			});
		},

		debounceRefresh: function() {
			window.clearTimeout(this.resizeTimer);
			this.resizeTimer = window.setTimeout(this.refreshAll.bind(this), 150);
		},
	};

	brandSlider.init();
});
